import {
  Box,
  Container,
  Heading,
  Text,
  Card,
  CardBody,
  Image,
  Link,
  Flex,
  useColorModeValue,
} from "@chakra-ui/react";

export function LandingPage() {
  const cardBg = useColorModeValue("gray.800", "gray.700");
  const cardText = useColorModeValue("gray.100", "gray.200");

  return (
    <Box
      minH="100vh"
      py={10}
      bgGradient="linear(to-br, gray.900, blue.900)"
    >
      <Container maxW="container.lg" textAlign="center">
        {/* Header */}
        <Heading
          as="h1"
          size="2xl"
          mb={4}
          className="bg-gradient-to-r from-sky-400 to-cyan-300 bg-clip-text text-transparent font-extrabold uppercase"
        >
          Never Games
        </Heading>
        <Text fontSize="lg" color="gray.400" mb={10}>
          Web Game Development Studio
        </Text>

        {/* Our Games Section */}
        <Heading
          as="h2"
          size="lg"
          textTransform="uppercase"
          color="cyan.300"
          mb={6}
        >
          Our Games
        </Heading>

        {/* Карточка по центру */}
        <Flex justify="center">
          <Link
            href="https://yandex.ru/games/developer/39984"
            isExternal
            className="no-underline"
          >
            <Card
              bg={cardBg}
              shadow="lg"
              rounded="2xl"
              transition="all 0.3s ease"
              _hover={{ transform: "scale(1.05)", shadow: "xl" }}
              w="sm"
            >
              <Image
                src="https://yastatic.net/naydex/games-yandex-ru/y4jG7m391/b0a709Tb/DGcDtLLxWMT3FPbSNvykFEUxupwf7NftjQC3wMc3zJSTfc2IjgFp5xw5PHfblZNf-o3AGABimEs4v3zmiPD0H9ijIsF2RejA0hDjRjJdMcFxNR4MW_9kThvydGNw5S63RUwtiL4QDJboHXrRCgAXyX8PRL-mZg1szrs8gt9VpAgvZkIyBLSpp3V0pqG3qQRXFndKTk_eJzzI8IWBseeutVW9Tyrcko6y6FzZsW7iJXmMv7WthMVfDVx4j-E9JeVbHmRDIBZX24dkh0ShJTk05NSV-c9-jdVMabPFMfL1TISV3V3pLPCdY5vNu5IvAnd6n0zHf0dHDFxPSZ5Tr3YEG-ynoCKHR4lVx_SWsBebd4dGNHk-no8HzvmxJTCBVp9nJ7y8GD9zzfAqrznA7uIU6x9PFD-1dY1u7ci_w5939JivBTDDtIdL9uUWNbKF-dWnJTWLrUyc5j2KgAczcza91sT830tsEk9Tk/pjpg464x261"
                alt="KS 2 Snipers"
                borderTopRadius="2xl"
                objectFit="cover"
                maxH="200px"
              />
              <CardBody>
                <Heading
                  as="h5"
                  size="md"
                  fontWeight="bold"
                  color={cardText}
                  className="hover:text-cyan-300"
                >
                  KS 2 Snipers
                </Heading>
              </CardBody>
            </Card>
          </Link>f
        </Flex>
      </Container>
    </Box>
  );
}
